module.exports = {
	"articleTitle1": "Merging diversity and harmony in the Angell Hall complex",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "Angell Hall",
	"bathroomrating": [
		{
			"rating": 2,
			"bathroom": "Main Entrance"
		}
	],
	"articleLink2": "https://www.michigandaily.com/content/2009-03-05/bywh-construction-angell-hall",
	"articleSnippet1": "Mar 23, 2011 ... Angell Hall is just one of the four buildings collectively referred to as the Angell \nHall complex. A series of interconnected halls, the complex ...",
	"articleSnippet2": "Mar 4, 2009 ... Before it was home to the Fishbowl or a warm shortcut between the Diag and \nState Street during the winter, Angell Hall was the University's ...",
	"articleLink1": "#",
	"articleTitle2": "BYWH: The construction of Angell Hall",
	"address": "435 State St, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/161208/eyx.NEW_.Racism%26Safety%40Michigan.12.08.16.071%20copy.jpg?itok=3v5gVlvt",
			"caption": "Alum. Jonte Jones speaks about racism and safety at the university following the recent elections in Angell Hall on Thursday.",
			"author": "Elizabeth Xiong"
		}
	],
	"position": {
		"lat": 42.276606,
		"lng": -83.7401
	},
	"tips": [
		{
			"text": "4th Floor Angell is a weird maze of insanity. Give yourself time to find a professor's office because you will get lost. It's very counter-intuitive.",
			"person": "Rebecca Lerner"
		},
		{
			"text": "No good study spots in this building outside of the fishbowl. Alternatives include UMMA, the Union, the SAB, UGLi, and Hatcher.",
			"person": "Abe Lofy"
		}
	],
	"totalMisc": 0,
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/angellhall.json
// module id = 810
// module chunks = 0